<template>
  <label class="icon-box" @click="handleClick">
    <auth-img class="icon-img" src="@/assets/img/chat/upload.png" alt="" />
    <div class="icon-label">查看患者</div>
  </label>
</template>
<script setup>
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'
const props = defineProps({
  workOrderGroupInfo: {
    type: Object,
    required: true,
    default: () => {}
  }
})
const router = useRouter()
const handleClick = () => {
  const { doctorInfo = {} } = props.workOrderGroupInfo || {}
  router.push({
    path: '/patient',
    query: {
      doctorId: doctorInfo.businessId
    }
  })
}
</script>
<style scoped lang="scss">
@import '../../index.scss';
</style>
